module.exports = __webpack_public_path__ + "img/electricMotorcycle-red.195f9269.svg";